/* jsEffect
--------------------------------------------------*/
$(function () {
  $(window).on('scroll load', function () {
    var sc = $(window).scrollTop(),
      wh = $(window).height();

    $('.fadeup, .fadein, .effect, .app').each(function (index, el) {
      var pos = $(el).offset().top;
      if (pos < sc + wh * 0.8) {
        $(el).addClass('on');
      }
    });
  });
});

/*
* menu
*/
$(function () {
  var state = false;
  var scrollpos;

  $('.toggle').click(function () {
    if (!state) {
      scrollpos = $(window).scrollTop();
      $('body').addClass('fixed');
      $('.main_nav').addClass('on');
      $('#header').addClass('on');
      $('.toggle').addClass('active');
      state = true;
    } else {
      $('body').removeClass('fixed');
      window.scrollTo(0, scrollpos);
      $('.main_nav').removeClass('on');
      $('#header').removeClass('on');
      $('.toggle').removeClass('active');
      state = false;
    }
  });

  $('.main_nav .btn_close, #header .btn_close').click(function () {
    if (state) {
      $('body').removeClass('fixed');
      window.scrollTo(0, scrollpos);
      $('.main_nav').removeClass('on');
      $('#header').removeClass('on');
      $('.toggle').removeClass('active');
      state = false;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.has_child').forEach(item => {
    const toggle = item.querySelector(':scope > a');
    if (!toggle) return;

    toggle.addEventListener('click', e => {
      e.preventDefault();
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.has_child.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  const mqSp = window.matchMedia('(max-width: 840px)');

  document.querySelectorAll('.has_g_child').forEach(item => {
    const trigger = item.querySelector(':scope > a');
    if (!trigger) return;

    trigger.addEventListener('click', e => {
      e.stopPropagation();
      if (!mqSp.matches) return;
      e.preventDefault();
      item.classList.toggle('g_child_active');
    });
  });

  const btnSearch = document.querySelector('.btn_search');
  const searchBtnClose = document.querySelector('.search_area .btn_close');
  const searchArea = document.querySelector('.search_area');

  if (btnSearch && searchArea) {
    btnSearch.addEventListener('click', () => {
      searchArea.classList.toggle('is_open');

      if (searchArea.classList.contains('is_open')) {
        btnSearch.classList.add('is_active');
        searchArea.querySelector('input[type="search"]')?.focus();
      } else {
        btnSearch.classList.remove('is_active');
      }
    });
  }

  if (searchBtnClose && searchArea) {
    searchBtnClose.addEventListener('click', () => {
      searchArea.classList.remove('is_open');
      btnSearch?.classList.remove('is_active');
    });
  }
});

/*
* acc
*/
$('.acc').on('click', function () {
  $(this).toggleClass('on').next().slideToggle();
});

if (window.matchMedia('(max-width: 840px)').matches) {
  $('.sp_acc').click(function (e) {
    if ($(e.target).closest('.has_g_child').length) return;

    $(this).toggleClass('acc_active');
    $(this).children('.childs').slideToggle().toggleClass('on');
  });

  $('.sp_acc > a').on('click', function (e) {
    e.preventDefault();
  });
}

/*
* header
*/
$(function () {
  $(window).on('scroll', function () {
    if ($(window).scrollTop()) {
      $('#header').addClass('on');
      $('body').addClass('scroll');
    } else {
      $('#header').removeClass('on');
      $('body').removeClass('scroll');
    }
  });
});

/*
* floating
*/
document.addEventListener('DOMContentLoaded', () => {
  const floating = document.querySelector('.floating');
  const btnBl = document.querySelector('.floating .btn_bl');
  const footer = document.querySelector('footer');

  if (btnBl && floating) {
    btnBl.addEventListener('click', () => {
      floating.classList.toggle('is_open');
    });
  }

  document.addEventListener('click', e => {
    if (!e.target.closest('.floating')) {
      floating?.classList.remove('is_open');
    }
  });

  if (footer && floating) {
    const observer = new IntersectionObserver(entries => {
      if (window.matchMedia('(max-width: 840px)').matches) {
        entries.forEach(entry => {
          floating.classList.toggle('is_hidden', entry.isIntersecting);
        });
      }
    });

    observer.observe(footer);
  }
});
/* tab */
$(function () {
  var $tabBoxes = $('.tab_box');

  function changeTab($tabBox, index) {
    var $tabButtons = $tabBox.find('.tab_btn_list > .tab_btn');
    var $tabPanels = $tabBox.find('.tab_panel');

    if (index < 0 || index >= $tabPanels.length) return false;

    $tabButtons.removeClass('active').eq(index).addClass('active');
    $tabPanels.removeClass('active').eq(index).addClass('active');

    return true;
  }

  // タブ一覧の上端へ移動
  function scrollToTabList($tabBox) {
    var $tabList = $tabBox.find('.tab_btn_list').first();

    if (!$tabList.length) return;

    // タブ切り替え後のレイアウトが確定してから位置を取得
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var headerHeight = $('#header').outerHeight() || 0;
        var position = $tabList.offset().top - headerHeight - 20;

        window.scrollTo({
          top: Math.max(position, 0),
          left: 0,
          behavior: 'auto'
        });
      });
    });
  }

  function activateTabFromHash(hash, shouldScroll) {
    if (!/^#tab_panel-\d+$/.test(hash)) return false;

    // id または data-tab-hash から対象タブを取得
var $targetPanel = $(hash);

if (!$targetPanel.length || !$targetPanel.hasClass('tab_panel')) {
  $targetPanel = $(
    '.tab_panel[data-tab-hash="' + hash.slice(1) + '"]'
  ).first();
}

if (!$targetPanel.length) {
  return false;
}

    var $tabBox = $targetPanel.closest('.tab_box');

    if (!$tabBox.length) return false;

    var $tabPanels = $tabBox.find('.tab_panel');
    var index = $tabPanels.index($targetPanel);

    if (!changeTab($tabBox, index)) return false;

    if (shouldScroll) {
      scrollToTabList($tabBox);
    }

    return true;
  }

  $tabBoxes.each(function () {
    var $tabBox = $(this);
    var $tabButtons = $tabBox.find('.tab_btn_list > .tab_btn');
    var $tabPanels = $tabBox.find('.tab_panel');

    $tabButtons.on('click', function () {
      var index = $tabButtons.index(this);

      if (!changeTab($tabBox, index)) return;

      // data-tab-hashがない場合はパネルのidを使用
      var tabHash =
        $tabPanels.eq(index).attr('data-tab-hash') ||
        $tabPanels.eq(index).attr('id');

      if (tabHash && window.location.hash !== '#' + tabHash) {
        history.pushState(null, '', '#' + tabHash);
      }
    });
  });

  // head内で保存された初回ハッシュ、または現在のURLを使用
  var initialHash = window.initialTabHash || window.location.hash;

  if (activateTabFromHash(initialHash, true)) {
    // head内で一時的に削除されたハッシュをURLへ戻す
    if (window.location.hash !== initialHash) {
      history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search + initialHash
      );
    }
  } else {
    $tabBoxes.each(function () {
      changeTab($(this), 0);
    });
  }

  // URL末尾を手動変更した場合にもタブを切り替える
  window.addEventListener('hashchange', function () {
    activateTabFromHash(window.location.hash, true);
  });

  // ブラウザの「戻る・進む」にも対応
  window.addEventListener('popstate', function () {
    activateTabFromHash(window.location.hash, true);
  });

  // 画像読み込み後にブラウザ標準のアンカー移動が発生しても位置を補正
  $(window).on('load', function () {
    activateTabFromHash(window.initialTabHash || window.location.hash, true);
  });
});
/* modal */
const overlay = document.getElementById('overlay');
const modal = overlay ? overlay.querySelector('.modal') : null;

if (overlay && modal) {
  document.querySelectorAll('.card').forEach(card => {
    card.addEventListener('click', () => {
      const val = card.dataset.video;
      const ytId = extractYouTubeId(val);

      modal.querySelectorAll('video, iframe').forEach(el => el.remove());

      if (ytId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`;
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'width:100%;aspect-ratio:16/9;border:none;display:block;';
        modal.insertBefore(iframe, modal.querySelector('#closeBtn'));
      } else {
        const video = document.createElement('video');
        video.src = val;
        video.controls = true;
        video.autoplay = true;
        video.style.cssText = 'width:100%;aspect-ratio:16/9;display:block;background:#000;';
        modal.insertBefore(video, modal.querySelector('#closeBtn'));
      }

      overlay.classList.add('open');
    });
  });

  document.getElementById('closeBtn')?.addEventListener('click', closeModal);

  overlay.addEventListener('click', e => {
    if (e.target === overlay) closeModal();
  });
}

function closeModal() {
  overlay?.classList.remove('open');

  modal?.querySelectorAll('video, iframe').forEach(el => {
    el.src = '';
    el.remove();
  });
}

function extractYouTubeId(input) {
  const match = input.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})|^([A-Za-z0-9_-]{11})$/
  );

  return match ? (match[1] || match[2]) : null;
}

/* anchor */
$('a[href^="#"]').on('click', function (e) {
  var href = $(this).attr('href');

  if (href === '#' || href === '') return;

  var target = $(href);
  if (!target.length) return;

  e.preventDefault();

  // アンカー先が非表示のタブ内にある場合は、先にそのタブを表示
  var $targetPanel = target.closest('.tab_panel');
  var $tabBox = target.closest('.tab_box');

  if ($targetPanel.length && $tabBox.length) {
    var $tabButtons = $tabBox.find('.tab_btn_list > .tab_btn');
    var $tabPanels = $tabBox.find('.tab_panel');
    var targetIndex = $tabPanels.index($targetPanel);

    if (targetIndex !== -1) {
      $tabButtons.removeClass('active').eq(targetIndex).addClass('active');
      $tabPanels.removeClass('active').eq(targetIndex).addClass('active');
    }
  }

  // クリックしたアンカーをブラウザのURLへ反映
  if (window.location.hash !== href) {
    history.pushState(null, '', href);
  }

  var headerHeight = $('#header').outerHeight() || 0;
var extraOffset = href === '#wellbeing03' ? 120 : 20;
var position = target.offset().top - headerHeight - extraOffset;

  $('html, body').animate(
    {
      scrollTop: position
    },
    500,
    'swing'
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('.js-modalOpen');

  openButtons.forEach(openButton => {
    const menu = openButton.closest('.ir-menu');
    if (!menu) return;

    const modal = menu.querySelector('.js-modalContent');
    const closeButton = menu.querySelector('.js-modalClose');
    if (!modal) return;

    openButton.addEventListener('click', e => {
      e.preventDefault();
      modal.classList.add('is-active');
      document.body.classList.add('is-modal-open');
    });

    if (closeButton) {
      closeButton.addEventListener('click', e => {
        e.preventDefault();
        modal.classList.remove('is-active');
        document.body.classList.remove('is-modal-open');
      });
    }

    modal.addEventListener('click', e => {
      if (e.target === modal) {
        modal.classList.remove('is-active');
        document.body.classList.remove('is-modal-open');
      }
    });
  });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.popup_area .btn_area');

  if (btn) {
    e.stopPropagation();

    const popupArea = btn.closest('.popup_area');
    const popup = btn.nextElementSibling;

    if (!popup || !popup.classList.contains('popup_content')) {
      return;
    }

    // 同じ.popup_area内のほかのポップアップだけ閉じる
    popupArea
      .querySelectorAll('.popup_content.is-active')
      .forEach(function (el) {
        if (el !== popup) {
          el.classList.remove('is-active');
          el.previousElementSibling?.classList.remove('on');
        }
      });

    const isActive = popup.classList.toggle('is-active');
    btn.classList.toggle('on', isActive);

    return;
  }

  // ポップアップ内のクリックでは閉じない
  if (e.target.closest('.popup_area .popup_content')) {
    return;
  }

  // 外側クリックですべて閉じる
  document
    .querySelectorAll('.popup_area .popup_content.is-active')
    .forEach(function (popup) {
      popup.classList.remove('is-active');
      popup.previousElementSibling?.classList.remove('on');
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const isEnglish = window.location.pathname.startsWith('/en');

  document.querySelectorAll('.jp-only').forEach(function (el) {
    el.style.display = isEnglish ? 'none' : '';
  });

  document.querySelectorAll('.en-only').forEach(function (el) {
    el.style.display = isEnglish ? '' : 'none';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const logoLink = document.querySelector('.logo a');

  if (!logoLink) return;

  const isEnglish =
    location.pathname === '/en' ||
    location.pathname.startsWith('/en/');

  logoLink.href = isEnglish ? '/en' : '/';
});
// タブ内アンカー調整
(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function activateAnchorTab() {
  const hash = window.location.hash;

  if (!hash || hash === '#') {
    return false;
  }

  // タブ切り替え用ハッシュはアンカー移動処理から除外
  if (/^#tab_panel-\d+$/.test(hash)) {
    return false;
  }

    let target;

    try {
      target = document.querySelector(hash);
    } catch (error) {
      return false;
    }

    if (!target) {
      return false;
    }

    const targetPanel = target.closest('.tab_panel');
    const tabBox = target.closest('.tab_box');

    // タブ内のアンカーでなければ処理しない
    if (!targetPanel || !tabBox) {
      return false;
    }

    const tabButtons = Array.from(
      tabBox.querySelectorAll('.tab_btn_list > .tab_btn')
    );

    const tabPanels = Array.from(
      tabBox.querySelectorAll('.tab_panel')
    );

    const targetIndex = tabPanels.indexOf(targetPanel);

    if (targetIndex === -1) {
      return false;
    }

    // アンカーが含まれるタブを表示
    tabButtons.forEach(function (button, index) {
      button.classList.toggle('active', index === targetIndex);
    });

    tabPanels.forEach(function (panel, index) {
      panel.classList.toggle('active', index === targetIndex);
    });

    // レイアウト確定後にアンカー位置へ移動
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(function () {
          const header = document.querySelector('#header');
          const extraOffset = hash === '#wellbeing03' ? 120 : 20;
          const headerOffset = header
            ? header.getBoundingClientRect().height + extraOffset
            : extraOffset;

          const position =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;

          window.scrollTo({
            top: Math.max(position, 0),
            behavior: 'auto'
          });
        }, 300);
      });
    });

    return true;
  }

  // 画像などを含め、ページ全体の読み込み完了後に実行
  window.addEventListener('load', activateAnchorTab);

  // 同じページ内でURLのアンカーを手動変更した場合
  window.addEventListener('hashchange', function () {
    setTimeout(activateAnchorTab, 100);
  });

  // ブラウザの「戻る・進む」に対応
  window.addEventListener('popstate', function () {
    setTimeout(activateAnchorTab, 100);
  });
})();

// evaluationスクロール位置
(function () {
  const hash = window.location.hash;

  if (hash !== '#evaluation') return;

  // ブラウザ標準のアンカー移動を防止
  history.replaceState(
    null,
    '',
    window.location.pathname + window.location.search
  );

  window.addEventListener('load', function () {
    const target = document.querySelector(hash);
    if (!target) return;

    setTimeout(function () {
      const offset = 120;
      const position =
        target.getBoundingClientRect().top +
        window.scrollY -
        offset;

      window.scrollTo({
        top: position,
        behavior: 'auto'
      });

      // URLにハッシュだけ戻す（再スクロールは発生しない）
      history.replaceState(
        null,
        '',
        window.location.pathname +
          window.location.search +
          hash
      );
    }, 300);
  });
})();

// 「コミュニティ・社会貢献」
window.addEventListener('load', function () {
  if (
    window.location.pathname !== '/pages/social' ||
    window.location.hash !== '#workforcedevelopment03'
  ) {
    return;
  }

  setTimeout(function () {
    const tabs = document.querySelectorAll('.tab_btn');
    const panels = document.querySelectorAll('.tab_panel');

    if (!tabs[3] || !panels[3]) return;

    // 現在の選択状態を解除
    tabs.forEach(function (tab) {
      tab.classList.remove('active');
    });

    panels.forEach(function (panel) {
      panel.classList.remove('active');
    });

    // 「コミュニティ・社会貢献」を開く
    tabs[3].classList.add('active');
    panels[3].classList.add('active');

    // タブ一覧の位置へ移動
    const tabList = tabs[3].parentElement;
    const offset = 0;

    const position =
      tabList.getBoundingClientRect().top +
      window.scrollY -
      offset;

    window.scrollTo({
      top: position,
      behavior: 'auto'
    });
  }, 100);
});

/* 英語ページのリンク先調整 */
document.addEventListener('DOMContentLoaded', function () {
  const isEnglish =
    location.pathname === '/en' ||
    location.pathname.startsWith('/en/');

  if (!isEnglish) return;

  document.querySelectorAll('a[href]').forEach(function (link) {
    const url = new URL(link.href);

    if (
      url.origin === location.origin &&
      url.pathname === '/pages/overview'
    ) {
      url.pathname = '/en/pages/overview';
      link.href = url.href;
    }
  });
});